import React, { Component } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { UserData, getTempResidualData } from "../../api";
import Header from "../preapps/Header";
import Notifications from "react-notify-toast";
import "../../../sass/residuals.scss";

export default class UnprocessedResidual extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            residualTable: {
                data: [],
                total: 0,
            },
            page: 1,
            total_amount: 0,
            total: 0,
        };
    }

    componentDidMount() {
        UserData().then((response) => {
            this.setState({
                user: response,
            });
        });
        this.residualDataRefresh();
    }

    fetchMoreData = () => {
        this.setState(
            {
                page: this.state.page + 1,
            },
            function () {
                this.residualDataRefresh();
            },
        );
    };
    residualDataRefresh = () => {
        const data = {
            page: this.state.page,
        };
        getTempResidualData(data).then((response) => {
            if (response.status) {
                this.setState({
                    total: response.total,
                    total_amount: response.total_amount,
                });
                if (this.state.residualTable.data.length == 0) {
                    this.setState({
                        residualTable: response.data,
                    });
                } else if (this.state.residualTable.data.length > 0) {
                    this.setState({
                        residualTable: {
                            ...this.state.residualTable,
                            data: [
                                ...this.state.residualTable.data,
                                ...response.data.data,
                            ],
                        },
                    });
                }
            }
        });
    };

    renderTable = () => {
        const { residualTable } = this.state;
        const hasMore = residualTable.total > residualTable.data.length;
        return (
            <div style={{ height: "100vh" }}>
                <InfiniteScroll
                    dataLength={residualTable.data.length}
                    next={this.fetchMoreData}
                    hasMore={hasMore}
                    loader={<h4>Loading...</h4>}
                    endMessage={
                        <p style={{ textAlign: "center" }}>
                            <b>Yay! You have seen it all</b>
                        </p>
                    }
                    height={"600px"}
                >
                    <div class="tableFixHead">
                        <table class="table table-striped table-responsive">
                            <thead>
                                <tr>
                                    <th scope="col" className="text-center">
                                        ID
                                    </th>
                                    <th scope="col" className="text-center">
                                        Month
                                    </th>
                                    <th scope="col" className="text-center">
                                        Year
                                    </th>
                                    <th scope="col" className="text-center">
                                        Lead ID
                                    </th>
                                    <th scope="col" className="text-center">
                                        Organization ID
                                    </th>
                                    <th scope="col" className="text-center">
                                        User ID
                                    </th>
                                    <th scope="col" className="text-center">
                                        Processor
                                    </th>
                                    <th scope="col" className="text-center">
                                        MID
                                    </th>
                                    <th scope="col" className="text-center">
                                        DBA
                                    </th>
                                    <th scope="col" className="text-center">
                                        Volume
                                    </th>
                                    <th scope="col" className="text-center">
                                        Transaction
                                    </th>
                                    <th scope="col" className="text-center">
                                        Income
                                    </th>
                                    <th scope="col" className="text-center">
                                        Expense
                                    </th>
                                    <th scope="col" className="text-center">
                                        Net
                                    </th>
                                    <th scope="col" className="text-center">
                                        Agent Net
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(residualTable.data).map(
                                    (item, key) => {
                                        return (
                                            <tr className="text-center">
                                                <td className="text-center">
                                                    {item[1].id}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].month}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].year}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].lead_id}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].organization_id}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].user_id}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].processor}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].mid}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].dba}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].volume}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].transaction}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].income}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].expense}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].net}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].agent_net}
                                                </td>
                                            </tr>
                                        );
                                    },
                                )}
                            </tbody>
                        </table>
                    </div>
                </InfiniteScroll>
            </div>
        );
    };
    render() {
        const { user, showAlert, alertHeader, alertMessage, variant } =
            this.state;
        return (
            <div className="website-wrapper application-page residualPage">
                <Header
                    header_user_name={user.name}
                    user={user}
                    onLogout={this.logout}
                />
                <div className="page-bottom-wrap">
                    <div
                        id="page-content-wrapper"
                        className=""
                        style={{ height: "100vh" }}
                    >
                        <Notifications />
                        {showAlert && (
                            <Alert
                                showAlert={showAlert}
                                heading={alertHeader}
                                message={alertMessage}
                                variant={variant}
                                handleDismissible={() => {
                                    this.setState({ showAlert: false });
                                }}
                            />
                        )}
                        <div>
                            <div className="row" style={{ height: "100vh" }}>
                                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                                <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                                    {this.renderTable()}
                                </div>
                                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
